import { AssignmentTurnedInOutlined, EditOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useState } from "react";
import { ContextLabel, EditContextModal } from "src/components";
import { IssueDto, IssueSummaryDto, useEditIssueContext } from "src/http";

interface Props {
  issue: IssueDto | IssueSummaryDto;
  isEditable: boolean;
  openDrawerOnClick?: boolean;
  sx?: SxProps;
}

const IssueContextProperty = (props: Props) => {
  const { context } = props.issue;
  const [isEditModalVisible, setIsEditModalVisible] = useState<boolean>(false);
  const { mutate: editIssueContext } = useEditIssueContext();

  async function handleContextChanged(
    contextActionItemGuid: string | null,
    _currentContextActionItemGuid: string | null
  ) {
    editIssueContext({
      issueGuid: props.issue.guid,
      contextActionItemGuid: contextActionItemGuid,
      assignTeamSlug: props.issue.assignedTeam?.slug,
      createdByUserId: props.issue.createdByUser.userId,
    });
    setIsEditModalVisible(false);
  }

  return (
    <>
      <Stack direction="row" spacing={0.25} sx={{ alignItems: "center", ...props.sx }}>
        <AssignmentTurnedInOutlined />
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          {context == null ? (
            <Typography variant="placeholder">Connect to Context</Typography>
          ) : (
            <ContextLabel context={context} hideTeamName openDrawerOnClick={props.openDrawerOnClick} />
          )}
        </Box>

        {props.isEditable && (
          <IconButton size="small" sx={{ color: "rgba(0, 0, 0, 0.3)" }} onClick={() => setIsEditModalVisible(true)}>
            <EditOutlined />
          </IconButton>
        )}
      </Stack>

      {props.isEditable && (
        <EditContextModal
          open={isEditModalVisible}
          context={props.issue.context}
          onUpdateClicked={handleContextChanged}
          onCancelled={() => setIsEditModalVisible(false)}
        />
      )}
    </>
  );
};

export { IssueContextProperty };
